import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../components/mweb/Icon/Icon';
import { RUPEE_SYMBOL } from 'hb-redux-store/util/constantServices';

const PaymentSummary = props => {
  const {
    summary,
    onCheckChange,
    onShowSummary,
    source = 'PAYMENT',
    paymentModeRef,
  } = props;
  const selected = summary?.isPartialPayment;
  const walletBalance = summary?.billingDetails?.hbWalletAmount;
  const walletSummaryRef = React.useRef();
  const setPaymentSummaryPosition = () => {
    const summaryElem = walletSummaryRef.current;
    const paymentModeElem = paymentModeRef.current;
    if (summaryElem && paymentModeElem) {
      const {
        top = null,
        left = null,
        width = null,
      } = paymentModeElem.getBoundingClientRect();
      // console.log('summaryElem: ', 'Left: ', left, '\tTop: ', top, '\tHeight: ', height, '\tWidth: ', width);
      if (left) {
        // summaryElem.style.left = `${left + width + 10}px`;
        // summaryElem.style.top = `${top}px`;
        // summaryElem.style.right = `inherit`;
        summaryElem.style.right = '5%';
        summaryElem.style.position = 'fixed';
      }
    }
  };
  useEffect(() => {
    if (source === 'PAYMENT') {
      window.addEventListener('resize', setPaymentSummaryPosition);
      if (summary) setPaymentSummaryPosition();
      return () =>
        window.removeEventListener('resize', setPaymentSummaryPosition);
    }
  });
  if (source === 'PAYMENT') {
    if (walletBalance) {
      return (
        <div className="payment-summary" ref={walletSummaryRef}>
          <div
            className="payment-summary--checkbox"
            onClick={() => onCheckChange({ isPartialPayment: !selected })}
          >
            <div>
              <Icon class="icon-payment-wallet-white-bg" size={24} />
              <span>Use VXL Money</span>
            </div>
            <div className="payment-summary--checkbox--amount-checkbox">
              <span className="bold">
                {RUPEE_SYMBOL}
                {summary?.billingDetails?.payableWalletAmount}
              </span>
              <Icon
                class={`icon-common-white-bg-checkbox-${
                  selected ? 'selected' : 'unselected'
                }`}
                size={20}
              />
            </div>
          </div>
          <div className="payment-summary--link flex-align-items-center">
            <span onClick={onShowSummary}>Transaction Summary</span>
            <Icon
              class="icon-common-white-arrow-right"
              size={10}
              onClick={onShowSummary}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="desktop-payments--summary justify-content--space-between">
          <div className="desktop-payments--summary--total-items">
            {`${summary?.billingDetails?.totalItems} ${
              summary?.billingDetails?.totalItems > 1 ? 'items' : 'item'
            }`}
          </div>
          <div className="desktop-payments--summary--divider" />
          <div className="desktop-payments--summary--total-items justify-content--space-between">
            <div className="desktop-payments--summary--label">
              Payable Amount :
            </div>
            <span>&nbsp;&nbsp;</span>
            <div className="desktop-payments--summary--payable">
              &#8377;{summary?.billingDetails?.payableAmount}
            </div>
          </div>
        </div>
      );
    }
  }
  if (source === 'RECHARGE_PAYMENT') {
    return (
      <div className="desktop-payments--summary recharge-payment flex-align-items-center">
        <div className="hb-icon">
          <Icon class="icon-payment-wallet-white-bg" size={22} />
        </div>
        {summary?.rechargeAmount && (
          <span>Add ₹{summary?.rechargeAmount} to VXL Money</span>
        )}
      </div>
    );
  }
  return false;
};

PaymentSummary.propTypes = {
  onCheckChange: PropTypes.func,
  summary: PropTypes.object,
  onShowSummary: PropTypes.func,
  source: PropTypes.oneOf(['RECHARGE_PAYMENT', 'PAYMENT']),
};

export default PaymentSummary;
